import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom'
import { getActiveWorldConfig } from '@gamecodex/world-config'
import { TopNav } from './TopNav'
import { Footer } from './Footer'
import { MistLayer } from './MistLayer'
import { LicenseGate } from './LicenseGate'
import { Toaster } from '@/components/ui'
import { AudioEngine } from '@/features/audio/AudioEngine'
import { DiceOverlay } from '@/features/dice/DiceOverlay'
import { useUtmCapture } from '@/features/marketing/useUtmCapture'
import { useLocale } from '@/i18n'
import { useServerProfileSync } from '@/lib/profile/serverProfile'

export function RootLayout() {
  // Capture UTM/drip params on landing so they survive the sign-up round-trip (7 Drip).
  useUtmCapture()
  // Pull the signed-in player's stored profile (portrait, prefs); local cache stays the fallback.
  useServerProfileSync()

  // License-restricted locales render a coming-soon gate — footer only, no nav, no
  // routed content (the edition is translated but its content can't ship in that
  // market yet). See WorldConfig.locales `restricted`.
  const { localeDef } = useLocale()
  // The 3D city page is a fixed full-screen play area: no footer under it (worlds on the 2D canvas keep theirs).
  const { pathname } = useLocation()
  const cityFullScreen = getActiveWorldConfig().eternalCity?.renderer === 'three' && /\/world\/cities\/[^/]+\/?$/.test(pathname)
  if (localeDef.restricted) {
    return (
      <div className="relative flex min-h-screen flex-col">
        <MistLayer />
        <main id="main" className="relative z-10 flex-1">
          <LicenseGate />
        </main>
        <Footer />
        <ScrollRestoration />
      </div>
    )
  }

  return (
    <div className="relative flex min-h-screen flex-col">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:bg-obsidian-200 focus:px-3 focus:py-2 focus:text-gold">
        Skip to content
      </a>
      <MistLayer />
      <TopNav />
      <main id="main" className="relative z-10 flex-1">
        <Outlet />
      </main>
      {!cityFullScreen && <Footer />}
      <AudioEngine />
      <Toaster />
      <DiceOverlay />
      <ScrollRestoration />
    </div>
  )
}
